// Package Imports
import React, { FunctionComponent } from 'react';

// Component Imports
import CheckBox from '@/components/checkbox';
import Toggle from '@/components/utility/toggle';

// Function Imports
import { toTitleCase } from '@/lib/functions/toTitleCase';

// Type Importts
import { CheckFilterProps, Filter } from '@/lib/types/filters';

// Config Imports
import { MERGE_FILTERS_MAP } from '@/lib/config/search/filterMergeMapping';

// Style Imports
import styles from './checkFilter.module.scss';
import mainStyles from '../searchFilters.module.scss';

const CheckFilter: FunctionComponent<CheckFilterProps> = ({
  data,
  add,
  selectedFilters,
  remove,
}) => {
  const update = (f: Filter, checked: boolean) => {
    if (checked) {
      add(f);
    } else {
      remove(f);
    }
  };

  const filterData = data?.filters || [];

  const isChecked = (value: string, parameter: string): boolean => {
    const mergeMap = MERGE_FILTERS_MAP[parameter] || {};
    const rawValues = Object.entries(mergeMap).find(([canonical]) => canonical === value)?.[1] || [value];
    return selectedFilters.some((f) => f.parameter === parameter && rawValues.includes(f.value));
  };

  return (
    filterData.length > 0 &&
    filterData.map((f, i) => (
      <div key={`f-${i}`} className={mainStyles.wrapper}>
        <span className={mainStyles.title}>{toTitleCase(f.label)}</span>
        {f.items.slice(0, 5).map((ff, ii) => (
          <CheckBox
            key={`chk-${i}-${ii}`}
            label={toTitleCase(ff.label)}
            data={{
              parameter: f.parameter,
              value: ff.value,
            } as Filter}
            isChecked={isChecked}
            onCheck={update}
            disabled={ff.disabled}
          />
        ))}
        {f.items.length > 5 && (
          <Toggle
            clickElement={<span>View All</span>}
            clickClass={styles.click}
            clickActiveClass={styles.active}
            childClass={styles.child}
            noToggleClass={styles.noToggle}
            buttonPosition="bottom"
          >
            {f.items.slice(5).map((ff, ii) => (
              <CheckBox
                key={`chk-${i}-extra-${ii}`}
                label={toTitleCase(ff.label)}
                data={{
                  parameter: f.parameter,
                  value: ff.value,
                  name: toTitleCase(ff.label),
                } as Filter}
                isChecked={isChecked}
                onCheck={update}
                disabled={ff.disabled}
              />
            ))}
          </Toggle>
        )}
      </div>
    ))
  );
};

export default CheckFilter;
